import { gradients } from '@frontend/constants';
import { Button, Icon, Text, XStack, YStack } from '@frontend/web-react';
import { useAnalytics } from '@frontend/web/hooks';

type GiftBannerProps = {
  heading: string;
  label: string;
  onOpen: () => void;
  subheading: string;
};

export const GiftBanner = ({ heading, label, onOpen, subheading }: GiftBannerProps) => {
  const { track } = useAnalytics();

  const handleClick = () => {
    track({ event: 'bannerSelected', topic: 'gifts' });
    onOpen();
  };

  return (
    <YStack className="border-1 border-cream-200 p-lg rounded-lg-plus" style={{ background: gradients.giftBanner.css }}>
      <XStack className="items-start md:items-center gap-md md:gap-lg flex-wrap md:flex-nowrap">
        <XStack className="items-start md:items-center gap-md min-w-0 flex-1 w-full md:w-auto">
          {/* eslint-disable-next-line tailwindcss/no-arbitrary-value */}
          <XStack className="items-center justify-center rounded-full border-1 border-mint-200 bg-white shrink-0 size-[84px] md:size-[64px]">
            <Icon color="primary" name="IconGift" size="lg" />
          </XStack>
          <YStack className="flex-1 gap-xs min-w-0">
            <Text className="text-textPrimary" type="h4">
              {heading}
            </Text>
            <Text className="text-cool-900" type="p-md">
              {subheading}
            </Text>
          </YStack>
        </XStack>
        <Button
          className="w-full md:w-auto md:ml-auto px-lg rounded-xl"
          onClick={handleClick}
          size="lg"
          variant="primary"
        >
          {label}
        </Button>
      </XStack>
    </YStack>
  );
};
